(() => {
  const root=window.Shopify?.routes?.root||'/';
  const words=['vibrator','vibrators','rechargeable','waterproof','lubricant','lubricants','silicone','rabbit','cleaner','bondage','dildo','dildos'];
  const distance=(a,b)=>{let row=Array.from({length:b.length+1},(_,i)=>i);for(let i=1;i<=a.length;i++){const next=[i];for(let j=1;j<=b.length;j++)next[j]=Math.min(next[j-1]+1,row[j]+1,row[j-1]+(a[i-1]===b[j-1]?0:1));row=next;}return row[b.length];};
  function parse(raw){
    let q=raw.trim().toLowerCase(),max=null,min=null;
    q=q.replace(/\b(?:under|below|less than|up to)\s*\$?\s*(\d+(?:\.\d{1,2})?)/g,(_,n)=>{max=n;return '';});
    q=q.replace(/\b(?:over|above|more than)\s*\$?\s*(\d+(?:\.\d{1,2})?)/g,(_,n)=>{min=n;return '';});
    q=q.replace(/\bbetween\s*\$?(\d+(?:\.\d+)?)\s*(?:and|to|-)\s*\$?(\d+(?:\.\d+)?)/g,(_,a,b)=>{min=a;max=b;return '';});
    q=q.replace(/\b(?:show me|looking for|find me|i want|please|a|an|some)\b/g,' ').replace(/\b(?:lubes?|lubricants?)\b/g,'lubricant').replace(/\bwater based\b/g,'water-based');
    q=q.split(/\s+/).filter(Boolean).map(w=>{if(w.length<5||words.includes(w))return w;const match=words.find(x=>distance(w,x)===1);return match||w;}).join(' ');
    return {q:q||'*',max,min};
  }
  function url(raw){const v=parse(raw),u=new URL(root+'search',location.origin);u.searchParams.set('q',v.q);u.searchParams.set('type','product');u.searchParams.set('options[prefix]','last');if(v.max!==null)u.searchParams.set('filter.v.price.lte',v.max);if(v.min!==null)u.searchParams.set('filter.v.price.gte',v.min);return u.href;}
  window.DutSmartSearch={parse,url};
  document.querySelectorAll('form[action*="/search"]').forEach(form=>{
    const input=form.querySelector('input[name=q]');
    if(!input||form.dataset.smartSearch||form.querySelector('[name=type]')?.value==='article')return;
    form.dataset.smartSearch='true';
    form.addEventListener('submit',event=>{
      const predictive=form.closest('predictive-search');
      if(!input.value.trim()||(!event.submitter?.classList.contains('dut-search-all')&&predictive?.querySelector('[aria-selected="true"] a')))return;
      event.preventDefault();
      event.stopImmediatePropagation();
      location.assign(url(input.value));
    },true);
  });
})();
